const environment = process.env.REACT_APP_ENVIRONMENT;
const flavour = process.env.REACT_APP_FLAVOUR;

const apiUrl = process.env.REACT_APP_API_URL;

export function getApiConfig() {
    if (environment !== undefined && flavour !== undefined) {
        return { URL: apiUrl };
    }

    return {};
}
